import {routeAuthenticationAdmin} from "../../base/utils";

export const processesRoutes = [
    {
        path: '/processes/create',
        name: 'Create Process',
        component: () => import('../views/CreateProcess.vue'),
        beforeEnter: routeAuthenticationAdmin,
        meta: {title: 'Crie seu Processo Seletivo'}
    },
    {
        path: '/processes/:key/edit',
        name: 'Edit Process',
        component: () => import('../views/CreateProcess.vue'),
        beforeEnter: routeAuthenticationAdmin,
        meta: {title: 'Crie seu Processo Seletivo'}
    },
    {
        path: '/processes/:key/result',
        name: 'Process Result',
        component: () => import('../views/ProcessResult.vue'),
        beforeEnter: routeAuthenticationAdmin,
        meta: {title: 'Classificação'}
    },
    {
        path: '/processes/:key/:formId/subscriptions',
        name: 'Gerenciar Inscrições',
        component: () => import('../views/ProcessSubscriptions.vue'),
        beforeEnter: routeAuthenticationAdmin,
        meta: {title: 'Gerenciar inscrições'}
    },
    {
        path: '/processes/list',
        name: 'Process List',
        component: () => import('../views/ProcessList.vue'),
        beforeEnter: routeAuthenticationAdmin,
        meta: {title: 'Meus Processos'}
    }
];
